Object.defineProperty(exports,"__esModule",{value:true});function emptyFunction(){}var BackAndroid={exitApp:emptyFunction,addEventListener:function addEventListener(){return{remove:emptyFunction};},removeEventListener:emptyFunction};exports.default=BackAndroid;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/apis/BackAndroid/index.js
 ** module id = 812
 ** module chunks = 0
 **/